export const tenantListSelector = state => state.tenant.tenantsList;
